import { permissionList } from '@/auth'
import { t } from '@/i18n'
import { Env } from '@nio-pow/mfe-vue3'

export const tabbarList = () => {
  const tabbars: any[] = [
    {
      name: t('deviceManagement'),
      link: '/equipment',
      icon: 'equipment',
      iconActive: 'equipment-f',
      // 高亮匹配的高级规则
      activeRule: '/equipment',
      // 若配置为数组，则满足其一权限即可
      // todo 读取字典表内 auth（desc）
      auth: [
        permissionList.POWERPRO_EQUIPMENT_PS,
        permissionList.POWERPRO_EQUIPMENT_PC,
        permissionList.POWERPRO_EQUIPMENT_EMETER,
        permissionList.POWERPRO_EQUIPMENT_WHITELABEL_ROOT,
      ],
      needLoading: true,
    },
    {
      name: t('workbench'),
      link: '/workbench',
      icon: 'workbench',
      iconActive: 'workbench-f',
      needLoading: true,
    },
    {
      name: t('mine'),
      link: '/personal/home',
      icon: 'mine',
      iconActive: 'mine-f',
      needLoading: true,
    },
  ]

  // 目前仅国内版本需要显示首页
  if (!Env.isInternational()) {
    tabbars.unshift({
      name: t('home'),
      link: '/equipment/powerswap/home',
      icon: 'home',
      iconActive: 'home-f',
    })
  }
  return tabbars
}
export const tabbarRoutes = tabbarList().reduce(
  (prev: any[], cur: any) => {
    prev.push(cur.link)
    return prev
  },
  [
    '/error',
    '/equipment/powerswap/list',
    '/equipment/powerswap/error',
    '/equipment/powercharger/error',
    '/equipment/powercharger/list',
    '/equipment/powercharger/group-mgt/list',
    '/equipment/emeter/list',
    '/equipment/whitelabel/list(-models)?/[^/]+', // 正则匹配符合的路由
  ],
)
